<template>
    <span
        :class="[
            needClass === false? '': 'cp label',
            themes? 'is-'+ themes: '',
            icon? 'icon-font '+ icon: '',
            text === '' && icon? 'icon-font-only': '',
            extendClass? extendClass: '',
        ]"
    >
        {{ text }}
        <slot></slot>
    </span>
</template>

<script>
    export default {
        props: {
            themes: {
                type: String,
                require: false,
                default: ''
            },
            text: {
                require: false,
                default: ''
            },
            icon: {
                type: String,
                require: false,
                default: ''
            },
            extendClass: {
                type: String,
                require: false,
                default: ''
            },
            needClass: {
                type: Boolean,
                require: false,
                default: true
            },
        },
    }
</script>

<style scoped lang="scss">
    $default: 'normal'; //預設的顏色組

    $color: map-get($colors, $default);
    $bg: map-get($color, 'background');
    $bd: map-get($color, 'border');
    $tx: map-get($color, 'text');

    .cp.label {
        display: inline-block;
        padding: 0 4px;
        background-color: $bg;
        border: $bd;
        border-radius: $border-radius;
        margin: 0 2px;
        font-size: $font-size-s;
        line-height: 1.6em;
        transition: $transition;

        &.is-circle {
            border-radius: 50%;
            color: $white;

            &.is-true {
                $type: map-get($colors, 'info');
                $text: map-get($type, 'text');

                background-color: $text;
            }

            &.is-false {
                $type: map-get($colors, 'danger');
                $text: map-get($type, 'text');

                background-color: $text;
            }

            &.is-null {
                $type: map-get($colors, 'warning');
                $text: map-get($type, 'text');

                background-color: $text;
            }
        }
            
        &.icon-font {

            &::before {
                vertical-align: bottom;
            }

            &.icon-font-only {

                &::before {
                    margin-right: 0;
                }
            }
        }

        @each $key, $map in $colors {
            $bg: map-get($map, 'background');
            $bd: map-get($map, 'border');
            $tx: map-get($map, 'text');

            &.is-#{$key} {
                background-color: $bg;
                border-color: $bd;
                color: $tx !important;
            }
        }
    }
</style>
